import * as Long from "long";
import * as React from "react";
import { connect } from "react-redux";
import { selectPlayerProfilePictureName } from "../../balancingSelectors/selectBalancingPictures";
import { selectPlayerLevelFromXp } from "../../balancingSelectors/selectBalancingXpLevels";
import { IdStyles } from "../../less/IdStyles";
import { selectPlayerInfo } from "../../selectors/selectPlayerInfo";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { NumberFormat } from "../generic/number-format/NumberFormat";
import { ProfilePicture } from "../player-profile/ProfilePicture";
export var _RankingPlacementLeaguePlayers = function (_a) {
    var ranking = _a.ranking, playerId = _a.playerId;
    var className = "ranking-placement-league";
    var max = ranking.max;
    var players = ranking.players;
    var position = max;
    var renderedPlayers = players.map(function (player, index) {
        var points = player.points !== undefined ? player.points.toNumber() : 0;
        var level = selectPlayerLevelFromXp(player.xp || Long.ZERO);
        var profilePictureName = selectPlayerProfilePictureName(player.profilePictureId || 0);
        var selected = playerId.equals(player.id || Long.NEG_ONE) ? IdStyles.StateSelected : "";
        var key = player.id ? player.id : index;
        var renderedElement = (React.createElement("div", { className: IdStyles.TableRowRanking + " " + selected, key: key.toString() },
            React.createElement("div", { className: className + "__generic-info flex flex--aligned" },
                React.createElement(NumberFormat, { amount: position, className: IdStyles.HeadlineOne }),
                React.createElement(ProfilePicture, { profilePictureName: profilePictureName, profilePictureClassName: "", profilePictureSize: IdStyles.ProfilePictureX_small }),
                React.createElement("div", { className: className + "__center-icon-text" },
                    React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconSmall },
                        React.createElement("div", { className: "w100 h100 flex flex--guts" },
                            React.createElement(NumberFormat, { amount: level, className: IdStyles.TextSmallBoldSecondaryOutline })))),
                React.createElement("span", { className: IdStyles.TextBoldPrimary }, player.name),
                React.createElement("div", { className: className + "__score-info flex" },
                    React.createElement("div", { className: "flex flex--row__reverse w100 h100" },
                        React.createElement(NumberFormat, { amount: points, className: IdStyles.TextBoldPrimary + " " + className + "__score" }),
                        React.createElement("div", { className: "td__divider" }))))));
        position++;
        return renderedElement;
    });
    return React.createElement("div", { className: "table " + className + "__table" }, renderedPlayers);
};
var mapState = function (state) { return ({
    playerId: selectPlayerInfo(state).playerId || Long.ZERO,
}); };
export var RankingPlacementLeaguePlayers = connect(mapState)(_RankingPlacementLeaguePlayers);



//////////////////
// WEBPACK FOOTER
// ./src/features/tournament-building/RankingPlacementLeaguePlayers.tsx
// module id = 2802
// module chunks = 3